module.exports = __webpack_public_path__ + "img/dic_local_point_v2.3f351394.gif";